import ProductImage from './ProductImage';
import { useProduct } from '@repo/widget-utils/services/hooks/product';

export default function ProductImageWidgetRoot(props: {
    productCatalogId: string;
    format?: string;
}) {
    const { data: product } = useProduct(props.productCatalogId);

    return (
        <ProductImage
            url={product?.coverImage.src}
            size="m"
            format={props.format as any}
            stretchToFit
        />
    );
}
